import { useState } from 'react';
import { Trophy } from 'lucide-react';
import { api, ApiError } from '../lib/api';
import { useI18n } from '../lib/i18n';
import { useAuth } from '../lib/auth';

/**
 * Thumbs-up polimórfico. Se coloca en cualquier "item real" (claim update, task,
 * email, message) pasándole entityType/entityId + el recipient (autor del item) +
 * un preview (snapshot). Regla: no auto-kudos (se oculta en tus propios items). El
 * server también lo bloquea. Registrar un nuevo tipo = renderizar este componente.
 */
export function KudosButton({ entityType, entityId, recipientUserId, entityPreview, given: initialGiven, label }: {
  entityType: string; entityId: string; recipientUserId: string | null;
  entityPreview?: Record<string, unknown>; given?: boolean; label?: string;
}) {
  const { t } = useI18n();
  const { me } = useAuth();
  const myId = me?.kind === 'tenant' ? String(me.user.id) : null;
  const [given, setGiven] = useState(!!initialGiven);
  const [busy, setBusy] = useState(false);
  // No auto-kudos: ocultar en items propios o sin autor conocido.
  if (!recipientUserId || (myId && String(recipientUserId) === myId)) return null;

  async function give() {
    if (given || busy) return;
    setBusy(true);
    try { await api.post('/api/evaluation/kudos', { entityType, entityId: String(entityId), recipientUserId, entityPreview }); setGiven(true); }
    catch (e) {
      // Límite anti-boicot: 1 kudo por día — avisar en el idioma del usuario.
      if (e instanceof ApiError && e.code === 'kudos_daily_limit') alert(t('kud.dailyLimit'));
    } finally { setBusy(false); }
  }
  return (
    <button type="button" onClick={give} disabled={busy || given} title={given ? t('kud.given') : t('kud.give')}
      style={{ border: 0, background: 'none', cursor: given ? 'default' : 'pointer', fontSize: label ? 12 : 13, opacity: given ? 1 : 0.6, lineHeight: 1, padding: '0 2px', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <Trophy size={14} strokeWidth={1.75} />{label ? <span>{label}</span> : null}
    </button>
  );
}
